import { Injectable } from '@angular/core';

/**
 * Armazenamento de token OAuth.
 * sessionStorage reduz persistência vs localStorage (fecha aba = limpa).
 * Evolução desejada: cookie HttpOnly via BFF (sem token no JS).
 */
@Injectable({
    providedIn: 'root',
})
export class TokenStorageService {
    private readonly storage: Storage = sessionStorage;

    getStorage(): Storage {
        return this.storage;
    }

    getAccessToken(): string | null {
        return this.storage.getItem('access_token');
    }

    clear(): void {
        this.storage.removeItem('access_token');
        this.storage.removeItem('refresh_token');
        this.storage.removeItem('id_token');
        this.storage.removeItem('expires_at');
        this.storage.removeItem('access_token_stored_at');
    }
}
